export default import.meta.ROLLDOWN_FILE_URL_CNO3Ae0Hiy8SPQkxUdc2pA